import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  saveFiltersAndSorter,
  fetchArcAdsSuccess,
  fetchArcAdsFailure,
  fetchArcAdDetailsSuccess,
  fetchArcAdDetailsFailure,
  fetchArcAdSourcesSuccess,
  fetchArcAdSourcesFailure,
  startSaving,
  finishSaving,
  clearData,
  setImagePreview,
  clearImagePreview,
  updateArcAdSuccess,
  updateArcAdFailure,
} = reducer.actions

export const fetchArcAds = createAction('arcAds/fetchArcAds')
export const fetchArcAdDetails = createAction('arcAds/fetchArcAdDetails')
export const fetchArcAdSources = createAction('arcAds/fetchArcAdSources')
export const createArcAd = createAction('arcAds/createArcAd')
export const updateArcAd = createAction('arcAds/updateArcAd')
export const deleteArcAd = createAction('arcAds/deleteArcAd')